import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FinalProductService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  FinalProductCreateDto,
  FinalProductDto,
  FinalProductExcelDownloadDto,
  FinalProductUpdateDto,
} from '../proxy/general/dtos/final-product';
import { FINALPRODUCT_CONFIG, FINALPRODUCT_FIELDS } from './final-product.config';
import { BaseHierarchicalCrudComponent, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';

@Component({
  selector: 'app-final-product',
  imports: [
    CommonModule,
    GenericForm,
    ZnHierarchicalViewComponent,
  ],
  providers: [ListService, FinalProductService, ConfirmationService],
  templateUrl: './final-product.html',
  styleUrl: './final-product.scss',
})
export class FinalProduct extends BaseHierarchicalCrudComponent<
  FinalProductDto,
  FinalProductCreateDto,
  FinalProductUpdateDto,
  FinalProductExcelDownloadDto
> {
  service = inject(FinalProductService);
  config = FINALPRODUCT_CONFIG;
  fields = FINALPRODUCT_FIELDS;

  protected prepareUpdateDto(data: any, selected: FinalProductDto): FinalProductUpdateDto {
    return {
      name: data.name,
      code: data.code,
      isActive: data.isActive,
      deactivationReasonId: data.deactivationReasonId,
      deactivationDate: data.deactivationDate,
      sapCode: data.sapCode,
      vendorId: data.vendorId,
      internalOrderId: data.internalOrderId,
      notes: data.notes,
      productCategoryId: data.productCategoryId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'FinalProduct';
  }
}
